import Button from '@pelckmans/elementis/components/button';
import PageHeader from '@pelckmans/elementis/components/page/page-header';
import Section from '@pelckmans/elementis/components/section';
import PelckmansLogo from '@pelckmans/elementis/icons/pelckmans';

import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useRoutes } from '../../hooks/useRoutes';
import ContentBody from '../../layout/content/ContentBody';
import ContentFooter from '../../layout/content/ContentFooter';
import ContentHeader from '../../layout/content/ContentHeader';
import Footer from '../../layout/footer/Footer';
import { buildGroupProps } from '../../utils/elementisUtils';
import ContactForm from './components/ContactForm';

import { useContext } from 'react';
import IdentityContext from '../../contexts/IdentityContext';
import Faq from './components/Faq';
import Platforms from './components/Platforms';

export type AuthRole = 'ANONYMOUS' | 'TEACHER' | 'STUDENT';

export default function Help() {
  const { t } = useTranslation();
  const { buildAbsolutePath } = useRoutes();
  const {
    identity: { isAuthenticated, isTeacherAlike },
  } = useContext(IdentityContext);

  useDocumentTitle(t('PAGES.HELP.DOCUMENT_TITLE'));

  const authRole: AuthRole = (() => {
    if (!isAuthenticated) return 'ANONYMOUS';
    if (isTeacherAlike) return 'TEACHER';

    return 'STUDENT';
  })();

  return (
    <div className="page help-page">
      <div className="page-content">
        <div className="main-layout">
          <div className="main-layout-container">
            <div className="content-layout">
              <main>
                <div className="margin-wrapper">
                  <ContentHeader
                    cover={
                      <PageHeader
                        headerText={t('PAGES.HELP.PAGE_TITLE')}
                        buttonGroupProps={buildGroupProps(
                          <Button
                            as="link"
                            href={buildAbsolutePath(['MY_METHODS'])}
                            prominence="neutral"
                            startIcon={<PelckmansLogo />}
                          >
                            {t('PAGES.HELP.RETURN_TO_PLATFORM.LABEL')}
                          </Button>,
                        )}
                      />
                    }
                  />
                  <ContentBody>
                    <div className="content">
                      <div className="list-sections">
                        <Section title={t('PAGES.HELP.SECTIONS.PLATFORMS.TITLE')}>
                          <Platforms />
                        </Section>
                        <Section title={t('PAGES.HELP.SECTIONS.FAQ.TITLE')}>
                          <Faq authRole={authRole} />
                        </Section>
                      </div>
                      <Section title={t('PAGES.HELP.SECTIONS.CONTACT.TITLE')}>
                        <ContactForm authRole={authRole} />
                      </Section>
                    </div>
                  </ContentBody>
                  <ContentFooter>
                    <Footer />
                  </ContentFooter>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
